'use client'

import { IRedux } from '@/app/[locale]/_store/types'
import { Container, HStack, Separator, Text } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { useTranslations } from 'next-intl'
import React from 'react'
import { useSelector } from 'react-redux'

export default function CopyrightBar() {
  const t = useTranslations()
  const { data } = useSelector((state: IRedux) => state.settings)

  return (
    <Container maxW={'1200px'} pb={'48px'}>
      <Separator />
      <HStack mt={8} justifyContent={'space-between'} color={'text.muted'}>
        <Text>
          &copy; {dayjs().year()} {data?.data?.shipper_name}.{' '}
          {t('all_right_reserved')}.
        </Text>
        <Text>
          Powered by{' '}
          <a href='https://delever.uz/' target='_blank'>
            Delever
          </a>
        </Text>
      </HStack>
    </Container>
  )
}
